export const processString = (val) => {
    // 移除所有百分号
    const stringWithoutPercent = val?.toString().replace(/[^0-9\.\+-]/g, '');
    // 转换为数字
    const numericValue = parseFloat(stringWithoutPercent);
    return numericValue;
};
